import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import LiveDemos from './components/LiveDemos';
import WhyThisWins from './components/WhyThisWins';
import MarketInefficiency from './components/MarketInefficiency';
import LeadGeneration from './components/LeadGeneration';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628] text-white font-['Inter']">
      <Navigation isScrolled={isScrolled} />
      <Hero />
      <LiveDemos />
      <WhyThisWins />
      <MarketInefficiency />
      <LeadGeneration />
      <Footer />
    </div>
  );
}
